import { render, staticRenderFns } from "./BusinessNameBeneficialOwnerRegistry.vue?vue&type=template&id=2386fcf6&scoped=true&"
import script from "./BusinessNameBeneficialOwnerRegistry.vue?vue&type=script&lang=js&"
export * from "./BusinessNameBeneficialOwnerRegistry.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameBeneficialOwnerRegistry.vue?vue&type=style&index=0&id=2386fcf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2386fcf6",
  null
  
)

export default component.exports